export const rulesAliases = {
  tp: "Тип партнера",
  reward_type: "Тип вознаграждения партнёра",
  date: "Дата начала работы выплаты",
  clients: "Диапазон клиентов (за месяц)",
  clients_ever: "Диапазон клиентов во время которого работает выплата",
  days_after_create: "Работа выплаты после регистрации партнера (в днях)",
  fix_cost: "Выплата за клиента",
  shar_coefficent: "Процент с операции клиента",
  cost_q: "Процент с остатка на счёту клиента",
  UL: "Юр. лицо",
  FL: "Физ. лицо",
  IP: "ИП",
  SC: "Скаут",
  revshare: "Фикс. + %",
  progressive: "Прогрессивная",
};
